module.exports = __webpack_public_path__ + "img/beauty-advice.b6eec4ee.svg";